export default {
  get_all: { method: "get", url: "api/pedidos" },
  show: { method: "get", url: "api/pedidos/{/id}" },
};
